/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import {FC} from 'react'
import {Routes, Route, BrowserRouter, Navigate} from 'react-router-dom'
import {PrivateRoutes} from './PrivateRoutes'
import {ErrorsPage} from '../modules/errors/ErrorsPage'
import {Logout, AuthPage, useAuth} from '../modules/auth'
import {App} from '../App'
import {ToastContainer} from 'react-toastify'
import {Contract} from '../modules/auth/components/Contract'
import {OpenQr} from '../modules/auth/components/OpenQr'
import {Login} from '../modules/auth/components/Login'

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const {PUBLIC_URL} = process.env

const AppRoutes: FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<App />}>
          <Route index element={<AuthPage />}></Route>
          <Route path='/open-account/auth' element={<AuthPage />} />
          <Route path='/open-account/auth/contract' element={<Contract />} />
          <Route path='/open-account/auth/sign-in' element={<Login />} />
          <Route path='/open-account/auth/createQr' element={<OpenQr />} />
          <Route path='/open-account' element={<Navigate to='/open-account/auth' />} />
          <Route path='/*' element={<Navigate to='/open-account/auth' />} />
        </Route>
      </Routes>
      <ToastContainer />
    </BrowserRouter>
  )
}

export {AppRoutes}
